import { Inline, Stack } from '@bedrock-layout/primitives';
import styled from 'styled-components';

export const ActionBlockContainer = styled(Inline)`
  flex-wrap: wrap;
  align-items: stretch;
  max-height: 30rem;
  overflow-y: scroll;
`;
export const ActionBlock = styled(Inline)`
  width: calc(50% - 0.5rem);
  border: 1px solid var(--color-whiteSmoke);
  border-radius: 6px;
  cursor: pointer;
`;

export const CustomClose = styled.div`
  position: absolute;
  top: 1rem;
  right: 2rem;
`;


export const IconContainer = styled.div`
  width: 10rem;
`;
